<template>
  <div class="posts-dynamic">
    <div class="posts-dynamic__ttl">
      Динамика постов
    </div>
    <table-preloader v-if="reqPending || !dataForChart || parentPending"/>
    <template v-if="!reqPending">
      <template v-if="errorLoading">
        <span>Ошибка, данных...</span>
      </template>
      <template v-else>
        <dynamic-controls
          :controls-list="controlsList.data"
          @onClick="handleClick"
        />
      </template>
      <bar
        :chart-data="datacollection"
        :options="options"
        :width="300"
        :height="160"
        v-if="isData"
      />
      <span v-else>
        По данной теме актуальных новостей нет
      </span>
    </template>
  </div>
</template>

<script>
import Bar from '../../../../../components/postsDynamicChart';
import { getAdditionalInfoApi, getTrustHourlyApi, getTrustDaylyApi } from '../../../../../api/posts';
import TablePreloader from '../../../../../components/preLoaders/tablePreloader.vue';
import dynamicControls from './components/dynamicControls.vue';

// chart helpers
import { setSumLabels, setDatasets } from '../../../../../helpers/charHelper';

import moment from 'moment';

export default {
  name: 'postsDynamic',
  components: { Bar, TablePreloader, dynamicControls },
  props: {
    openSidebar: {
      type: Boolean
    },
    parentDataForChart: {
      type: Object
    },
    parentPending: {
      type: Boolean
    },
  },
  data() {
    return {
      response: {},
      firstOpen: false,
      month: [
        'янв',
        'фев',
        'мар',
        'апр',
        'май',
        'июн',
        'июл',
        'авг',
        'сен',
        'окт',
        'ноя',
        'дек',
      ],
      controlsList: {
        data: {
          hour: {
            title: 'часы',
            property: 'publicationsgrowthwithtrust',
            prepareLabels: elem => elem[0],
            minSumLabel: 10,
            active: false,
          },
          days: {
            title: 'дни',
            property: 'publicationsgrowthdaily',
            prepareLabels: elem => {
              let dateArr = elem[0].split('-');
              let month = parseInt(dateArr[1]) - 1;

              return [elem[0].slice(-2), this.month[month]];
            },
            minSumLabel: 30,
            active: true,
            fontcolor: "blue"
          },
        },
        activeProperty: 'publicationsgrowthdaily',
      },
      reqPending: false,
      errorLoading: false,
      dataForChart: '',
      datacollection: '',
      allDataSum: null,
      options: {
        responsive: true,
        maintainAspectRatio: false,
        barValueSpacing: 0,
        scales: {
          xAxes: [{
            stacked: true,
            gridLines: {
              color: 'rgba(0, 0, 0, 0)',
            },
            ticks: {
              fontSize: 10,
              fontFamily: "Oswald",
              fontStyle: "bold",
              beginAtZero:true
            }
          }],
          yAxes: [{
            stacked: true,
            gridLines: {
              color: 'rgba(0, 0, 0, 0)',
            },
            ticks: {
              display: false,
              suggestedMax: 20,
            },
          }],

        },
        legend: {
          display: false,
        },
        tooltips: {
          callbacks: {
            label(tooltipItem) {
              return tooltipItem.yLabel;
            },
          },
        },
        plugins: {
          datalabels: {
            formatter: (value, ctx) => {
              if (ctx.chart.data.datasets.length) {
                const datasets = setDatasets(ctx);
                if (datasets.indexOf(ctx.dataset) === datasets.length - 1) {
                  return setSumLabels(datasets, ctx);
                }
              }
              return '';
            },
            anchor: 'start',
            align: (ctx) => {
              let minSumLabel = 10;
              const controlKeys = Object.keys(this.controlsList.data);
              controlKeys.forEach((item) => {
                if (this.controlsList.data[item].active) {
                  minSumLabel = this.controlsList.data[item].minSumLabel;
                }
              });
              if (ctx.chart.data.datasets.length) {
                const datasets = setDatasets(ctx);
                if (datasets.indexOf(ctx.dataset) === datasets.length - 1) {
                  return setSumLabels(datasets, ctx) < minSumLabel ? 'top' : 'bottom';
                }
              }
            },
            clamp: true,
            clip: true,
          },
        },
      },
      lastIndexHourTotal: 0,
      lastHourTotal: 0,
    };
  },
  computed: {
    isData() {
      return this.allDataSum;
    },
  },
  mounted() {
    this.$nextTick(() => {
      if (this.$route.params.id) {
        this.copyData();
      }
    });
  },
  watch: {
    openSidebar() {
      if (!this.firstOpen) {
        this.getAdditionalInfo();
        this.firstOpen = true;
      }
    },
    $route() {
      this.getAdditionalInfo();
    },
  },
  methods: {
    copyData () {
      this.allDataSum = 0;
      this.response = JSON.parse(JSON.stringify(this.parentDataForChart));
      this.getActiveAdditionalInfo();
    },
    handleClick(property) {
      if(this.controlsList.activeProperty !== property) {
        const controlKeys = Object.keys(this.controlsList.data);

        controlKeys.forEach((item) => {
          this.controlsList.data[item].active = !this.controlsList.data[item].active;
        });

        this.controlsList.activeProperty = property;
        this.getAdditionalInfo();
      }
    },
    getActiveAdditionalInfo() {
      this.dataForChart = this.response;
      this.datacollection = this.setDataCollection();
      this.setDataSumm();
    },
    getTrustBy() {
      if (this.controlsList.activeProperty === 'publicationsgrowthdaily') {
        const params = {
          thread_id: this.$route.params.id,
          from: moment().subtract(8,'d').format('YYYY-MM-DD') + '00:00:00',
          to: moment().format('YYYY-MM-DD') + '23:59:59',
        };

        getTrustDaylyApi(params)
          .then((resp) => {
            this.response = resp.data.total;
            this.getActiveAdditionalInfo();
            this.reqPending = false;
          })
          .catch(() => {
            this.errorLoading = true;
          });
      } else {
        const params = {
          thread_id: this.$route.params.id,
        };

        getTrustHourlyApi(params)
          .then((resp) => {

            this.response.negative = resp.data.total.negative.slice(0,7);
            this.response.positive = resp.data.total.positive.slice(0,7);
            this.response.netural = resp.data.total.netural.slice(0,7);
            this.response.total = resp.data.total.total.slice(0,7);

            this.getActiveAdditionalInfo();
            this.reqPending = false;
          })
          .catch(() => {
            this.errorLoading = true;
          });
      }
    },
    getAdditionalInfo() {
      this.allDataSum = 0;
      this.reqPending = true;
      this.errorLoading = false;

      this.getTrustBy();
    },
    setDataCollection() {
      let prepareFunc = null;
      const controlKeys = Object.keys(this.controlsList.data);
      controlKeys.forEach((item) => {
        if (this.controlsList.data[item].active) {
          prepareFunc = this.controlsList.data[item].prepareLabels;
        }
      });
      return {
        labels: this.dataForChart.negative.map(elem => prepareFunc(elem)),
        datasets: [
          {
            label: 'neutral',
            backgroundColor: '#c4c4c4',
            data: this.dataForChart.netural.map(elem => elem[1]),
          },
          {
            label: 'negative',
            backgroundColor: '#ED002B',
            data: this.dataForChart.negative.map(elem => elem[1]),
          },
          {
            label: 'positive',
            backgroundColor: '#03bb9a',
            data: this.dataForChart.positive.map(elem => elem[1]),
          }
        ],
      };
    },
    setDataSumm() {
      this.datacollection.datasets.forEach((item) => {
        item.data.forEach((dataItem) => {
          this.allDataSum += dataItem;
        });
      });
    },
    processLastHour() {
      const lastElement = this.dataForChart.total[this.dataForChart.total.length - 1];
      this.lastHourTotal = lastElement[1];
      this.lastIndexHourTotal = this.dataForChart.total.indexOf(lastElement);

      if (!this.lastHourTotal) {
        for (const item in this.dataForChart) {
          this.dataForChart[item].splice(this.lastIndexHourTotal, 1);
        }
      }
    },
  },
};
</script>

<style lang="stylus">
.posts-dynamic
  height 235px
  background #fff
  &__ttl
    padding: 0 0 7px 0;
    margin: 0 0 10px 0;
    font-family: "Oswald", "Arial", sans-serif;
    font-style: normal;
    font-weight: 300;
    font-size: 18px;
    line-height: normal;
    text-transform: uppercase;
    letter-spacing: 0.1em;
    border-bottom: 1px solid #c4c4c4;
</style>
